import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

const Checkout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [quizData, setQuizData] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showCouponInput, setShowCouponInput] = useState(false);
  
  const params = new URLSearchParams(location.search);
  const selectedPackage = params.get('package') || '24h';

  // Estados do pedido
  const [selectedTime, setSelectedTime] = useState(selectedPackage);
  const [extraRevision, setExtraRevision] = useState(false);

  // 👇 NOVOS ESTADOS PARA CUPOM
  const [couponCode, setCouponCode] = useState('');
  const [couponError, setCouponError] = useState('');
  const [couponSuccess, setCouponSuccess] = useState('');
  const [couponDiscount, setCouponDiscount] = useState(0); // Valor do desconto
  const [isCouponUsed, setIsCouponUsed] = useState(false); // Se cupom já foi usado
  const [isApplyingCoupon, setIsApplyingCoupon] = useState(false);
  const [couponType, setCouponType] = useState(null); // 'fixed' | 'percentage'
  const baseUrl = 'https://cantandovidas.com.br';

  const baseOptions = {
    '24h': { label: 'Entrega em 24h', basePrice: 47.90, time: '24h' },
    '48h': { label: 'Entrega em 48h', basePrice: 27.90, time: '48h' },
  };

  const EXTRA_REVISION_PRICE = 7.90;

  // Cálculo dinâmico (AGORA CONSIDERA DESCONTO)
  const currentBase = baseOptions[selectedTime];
  const subtotal = currentBase.basePrice + (extraRevision ? EXTRA_REVISION_PRICE : 0);
  const discountValue =
    couponType === 'percentage'
        ? subtotal * (couponDiscount / 100)
        : couponDiscount;
  const totalPrice = Math.max(0, subtotal - discountValue);
  const totalRevisions = extraRevision ? 2 : 1;

  useEffect(() => {
    const data = JSON.parse(sessionStorage.getItem('quizData') || '{}');
    setQuizData(data);
  }, []);

  // 👇 FUNÇÃO PARA VALIDAR CUPOM
  const applyCoupon = async () => {
  // 👈 FECHA MODAL IMEDIATAMENTE
  setShowCouponInput(false);
  
  if (!couponCode.trim()) {
    setCouponError('Digite um código de cupom');
    setShowCouponInput(true); // Reabre se inválido
    return;
  }

  if (!quizData.email) {
    setCouponError('É necessário informar o email primeiro');
    setShowCouponInput(true); // Reabre se inválido
    return;
  }

  setIsApplyingCoupon(true);
  setCouponError('');
  setCouponSuccess('');

  try {
    // 1. Verifica se email já tem pedido
    const checkEmailResponse = await fetch(baseUrl + '/api/check_coupon_email.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: quizData.email,
        coupon_code: couponCode.trim()
      })
    });

    const emailCheck = await checkEmailResponse.json();

    if (emailCheck.used) {
      setCouponError('Você já fez um pedido com este email. Cupons não são permitidos.');
      setShowCouponInput(true); // 👈 Reabre com erro
      setIsApplyingCoupon(false);
      return;
    }

    // 2. Valida cupom
    const couponResponse = await fetch(baseUrl + '/api/validate_coupon.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ coupon_code: couponCode.trim() })
    });

    const couponData = await couponResponse.json();

    if (couponData.success) {
      setCouponDiscount(couponData.discount_value);
      setCouponType(couponData.discount_type);
      setIsCouponUsed(true);
      // Modal já fechado + sucesso visual no badge
    } else {
      setCouponError(couponData.error || 'Cupom inválido');
      setShowCouponInput(true); // 👈 Reabre com erro
    }
  } catch (error) {
    setCouponError('Erro ao validar cupom. Tente novamente.');
    setShowCouponInput(true); // 👈 Reabre com erro
  } finally {
    setIsApplyingCoupon(false);
  }
};


  const removeCoupon = () => {
    setCouponCode('');
    setCouponDiscount(0);
    setCouponError('');
    setCouponSuccess('');
    setIsCouponUsed(false);
  };

  const recipientLabels = {
    'spouse': 'Esposo', 'wife': 'Esposa', 'son': 'Filho', 'daughter': 'Filha',
    'father': 'Pai', 'mother': 'Mãe', 'brother': 'Irmão', 'friend': 'Amigo',
    'myself': 'Eu mesmo', 'other': 'Outra pessoa'
  };

  const styleLabels = {
    'romantic': 'Romântico', 'rock': 'Rock', 'mpb': 'MPB', 'sertanejo': 'Sertanejo',
    'forro': 'Forró', 'jazz': 'Jazz', 'gospel': 'Gospel', 'reggae': 'Reggae',
    'rap': 'Rap/Hip-Hop', 'electronic': 'Eletrônico'
  };

  const eventTypeLabels = {
    'wedding': 'Casamento',
    'birthday': 'Aniversário',
    'graduation': 'Formatura',
    'corporate': 'Evento Corporativo',
    'religious': 'Evento Religioso',
    'other': 'Outro'
  };

  const voiceLabels = { 'female': 'Feminina', 'male': 'Masculina' };

  // 1. CRIAR PREFERÊNCIA DE PAGAMENTO (AGORA COM CUPOM)
  const createPreference = async () => {
    try {
      const timeLabel = selectedTime === '24h' ? '24h' : '48h';
      const revisionsLabel = totalRevisions === 1 ? '1 revisão' : `${totalRevisions} revisões`;
      
      const dynamicTitle = `🎵 Música Personalizada | Entrega em ${timeLabel} | ${revisionsLabel}`;

      const orderReference = `ORDER_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;

      const response = await fetch(baseUrl + '/api/create_preference.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          title: dynamicTitle,
          quantity: 1,
          unit_price: totalPrice, // 👈 PREÇO COM DESCONTO
          external_reference: orderReference,
          metadata: {
            email: quizData.email,
            deliveryTime: selectedTime,
            revisions: totalRevisions,
            typeGroup: quizData.typeGroup,
            recipient: quizData.recipient,
            targetName: quizData.targetName,
            style: quizData.styleGroup,
            coupon_code: couponCode.trim() || null, // 👈 CUPOM
            subtotal: subtotal, // 👈 SUBTOTAL ORIGINAL
            discount: couponDiscount // 👈 DESCONTO APLICADO
          }
        })
      });

      const preference = await response.json();
      preference.orderReference = orderReference;
      
      console.table(preference);
      console.log('🆔 ID:', preference.id);
      console.log('🔗 Link:', preference.init_point);
      console.log('💳 Preference:', preference);

      return preference;
    } catch (error) {
      console.error('Erro ao criar preferência:', error);
      throw error;
    }
  };

  // 2. SALVAR PEDIDO NO BANCO (COM CUPOM)
  const saveOrderToDB = async (preferenceId, userId, externalReference) => {
    const payload = {
      externalReference,
      preferenceId,
      userId,
      customerName: quizData.yourName || '',
      customerEmail: quizData.email || '',
      customerPhone: quizData.phone || '',
      deliveryTime: selectedTime,
      revisions: totalRevisions,
      subtotal: subtotal, // 👈 NOVO: SUBTOTAL SEM DESCONTO
      discount: couponDiscount, // 👈 NOVO: DESCONTO
      totalAmount: totalPrice, // 👈 TOTAL COM DESCONTO
      coupon_code: couponCode.trim() || null, // 👈 CUPOM
      typeGroup: quizData.typeGroup || '',
      recipient: quizData.recipient || '',
      recipientOther: quizData.recipientOther || '',
      targetName: quizData.personName || quizData.eventNames || '',
      eventType: quizData.eventType || '',
      eventOther: quizData.eventOther || '',
      eventNames: quizData.eventNames || '',
      styleGroup: quizData.style || '',
      styleOther: quizData.styleOther || '',
      voice: quizData.voice || '',
      qualities: quizData.qualities || '',
      memories: quizData.memories || '',
    };

    console.log('Payload para DB:', payload);

    try {
      const response = await fetch(baseUrl + '/api/save_order.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const text = await response.text();
        console.error('Erro HTTP ao salvar pedido:', response.status, text);
        throw new Error(`HTTP ${response.status}`);
      }

      const data = await response.json();
      if (!data.success) {
        console.error('API retornou erro ao salvar pedido:', data);
        throw new Error(data.error || 'Erro desconhecido na API');
      }

      console.log('Pedido salvo! ID:', data.order_id);
      return data;
    } catch (error) {
      console.error('Erro ao salvar pedido no banco:', error);
      throw error;
    }
  };

  const handleBuy = async () => {
    try {
      setIsModalOpen(true);
      const preference = await createPreference();
      
      if (preference?.init_point) {
        await saveOrderToDB(preference.id, preference.collector_id, preference.orderReference);

        const orderData = {
          ...quizData,
          deliveryTime: selectedTime,
          revisions: totalRevisions,
          extraRevision: extraRevision,
          subtotal: subtotal,
          discount: couponDiscount,
          totalAmount: totalPrice,
          coupon_code: couponCode.trim() || null,
          preferenceId: preference.id,
          collectorId: preference.collector_id,
          timestamp: new Date().toISOString()
        };
        sessionStorage.setItem('orderData', JSON.stringify(orderData));
        
        window.location.href = preference.init_point;
      } else {
        throw new Error('Erro na preferência');
      }
    } catch (error) {
      setIsModalOpen(false);
      console.error(error);
      alert('Erro ao processar pagamento. Tente novamente.');
    }
  };

    {/* 👇 MODAL SIMPLES DO CUPOM */}
    {showCouponInput && (
    <div className="coupon-modal-overlay" onClick={() => setShowCouponInput(false)}>
        <div className="coupon-modal" onClick={(e) => e.stopPropagation()}>
        <div className="coupon-modal-header">
            <h4>🎟️ Aplicar Cupom</h4>
            <button 
            className="close-coupon" 
            onClick={() => setShowCouponInput(false)}
            >
            ×
            </button>
        </div>
        
        <div className="coupon-modal-body">
            <div className="coupon-input-group">
            <input
                type="text"
                className="coupon-input"
                placeholder="Digite o código do cupom"
                value={couponCode}
                onChange={(e) => setCouponCode(e.target.value.toUpperCase())}
                autoFocus
                onKeyDown={(e) => {
                if (e.key === 'Enter' && !isApplyingCoupon) {
                    e.preventDefault();
                    applyCoupon();
                }
                }}
            />
            <button 
                className="btn-coupon"
                onClick={applyCoupon}
                disabled={isApplyingCoupon}
            >
                {isApplyingCoupon ? '⏳' : 'Aplicar'}
            </button>
            </div>

            {couponError && (
            <div className="coupon-message coupon-error">
                <span>⚠️</span>
                {couponError}
            </div>
            )}
        </div>
        </div>
    </div>
    )}


  return (
    <div className="checkout-page-wrapper">
      <style>{`
        .checkout-page-wrapper {
          --primary: #8B5CF6;
          --primary-dark: #7C3AED;
          --secondary: #EC4899;
          --accent: #F59E0B;
          --dark: #1F2937;
          --light: #F9FAFB;
          --text: #111827;
          --text-light: #6B7280;
          --success: #10B981;
          --error: #EF4444;
          --border: #E5E7EB;
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          background: var(--light);
          min-height: 100vh;
          padding-bottom: 3rem;
        }
        /* ... todos os estilos anteriores permanecem iguais ... */
        nav { background: white; padding: 1rem 0; border-bottom: 1px solid var(--border); }
        .nav-container { max-width: 1200px; margin: 0 auto; padding: 0 2rem; display: flex; justify-content: space-between; align-items: center; }
        .logo { font-size: 1.5rem; font-weight: 700; background: linear-gradient(135deg, var(--primary), var(--secondary)); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; }
        
        .checkout-container { max-width: 1300px; margin: 3rem auto; padding: 0 2rem; display: grid; grid-template-columns: 2fr 1fr; gap: 3rem; }
        
        .order-section { background: white; border-radius: 1.5rem; padding: 2.5rem; box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08); }
        .section-title { font-size: 1.5rem; font-weight: 700; margin-bottom: 1.5rem; color: var(--text); }
        
        .plans-display { display: grid; grid-template-columns: 1fr 1fr; gap: 1.5rem; margin-bottom: 1.5rem; }
        .plan-box { 
          border: 2px solid var(--border); 
          border-radius: 1rem; 
          padding: 1.5rem; 
          transition: all 0.3s; 
          cursor: pointer;
          position: relative;
        }
        .plan-box:hover { 
          border-color: var(--primary-dark); 
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(139, 92, 246, 0.15);
        }
        .plan-box.active { 
          border-color: var(--primary); 
          background: rgba(139, 92, 246, 0.08); 
          box-shadow: 0 0 0 4px rgba(139, 92, 246, 0.1);
        }
        .plan-time { font-size: 1.2rem; font-weight: 700; color: var(--primary); margin-bottom: 0.5rem; }
        .plan-price { font-size: 1.5rem; font-weight: 700; margin-bottom: 1rem; }
        .plan-features { list-style: none; padding: 0; font-size: 0.9rem; color: var(--text-light); }
        .plan-features li { margin-bottom: 0.5rem; display: flex; align-items: center; gap: 0.5rem; }
        .plan-features li:before { content: "✓"; color: var(--success); font-weight: bold; }
        .plan-box.active .plan-time { color: var(--primary-dark); }
        .plan-box.active .plan-price { color: var(--primary-dark); }

        .extra-offer-toggle {
          background: linear-gradient(135deg, #fef3c7, #fde68a);
          border: 2px solid var(--accent);
          border-radius: 1rem;
          padding: 1.25rem 1.5rem;
          margin: 1.5rem 0;
          cursor: pointer;
          transition: all 0.3s;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 1rem;
        }
        .extra-offer-toggle:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(245, 158, 11, 0.25);
        }
        .extra-offer-toggle.selected {
          background: linear-gradient(135deg, #d9f99d, #bef264);
          border-color: var(--success);
        }
        .extra-offer-content {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          flex: 1;
        }
        .extra-offer-icon {
          font-size: 1.5rem;
        }
        .extra-offer-text {
          font-size: 0.95rem;
          line-height: 1.4;
        }
        .extra-offer-text strong {
          color: var(--primary-dark);
        }
        
        .toggle-switch {
          position: relative;
          width: 56px;
          height: 30px;
          flex-shrink: 0;
        }
        .toggle-switch input {
          opacity: 0;
          width: 0;
          height: 0;
        }
        .toggle-slider {
          position: absolute;
          cursor: pointer;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: #ccc;
          transition: 0.3s;
          border-radius: 30px;
        }
        .toggle-slider:before {
          position: absolute;
          content: "";
          height: 22px;
          width: 22px;
          left: 4px;
          bottom: 4px;
          background-color: white;
          transition: 0.3s;
          border-radius: 50%;
          box-shadow: 0 2px 4px rgba(0,0,0,0.2);
        }
        .toggle-switch input:checked + .toggle-slider {
          background: linear-gradient(135deg, var(--success), #059669);
        }
        .toggle-switch input:checked + .toggle-slider:before {
          transform: translateX(26px);
        }
        
        /* 👇 ESTILOS NOVOS PARA CUPOM COMPACT */
        .coupon-applied-compact {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: linear-gradient(135deg, var(--success), #059669);
        color: white;
        padding: 0.75rem 1rem;
        border-radius: 0.75rem;
        font-size: 0.9rem;
        font-weight: 500;
        }
        .btn-remove-coupon-compact {
        background: rgba(255,255,255,0.2);
        border: none;
        color: white;
        font-size: 1.2rem;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        }
        .btn-remove-coupon-compact:hover {
        background: rgba(255,255,255,0.3);
        }

        .coupon-trigger:hover {
        background: rgba(139, 92, 246, 0.1) !important;
        transform: translateY(-1px);
        }
        .coupon-trigger.has-discount {
        background: rgba(16, 185, 129, 0.1) !important;
        color: var(--success) !important;
        }

        /* MODAL DO CUPOM */
        .coupon-modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0,0,0,0.5);
        z-index: 1500;
        display: flex;
        align-items: center;
        justify-content: center;
        backdrop-filter: blur(2px);
        animation: fadeIn 0.2s;
        }

        .coupon-modal {
        background: white;
        border-radius: 1rem;
        width: 90%;
        max-width: 400px;
        box-shadow: 0 20px 60px rgba(0,0,0,0.3);
        animation: slideUp 0.3s;
        }

        .coupon-modal-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 1.5rem 1.5rem 0;
        margin-bottom: 1rem;
        }

        .coupon-modal-header h4 {
        margin: 0;
        color: var(--text);
        font-size: 1.2rem;
        }

        .close-coupon {
        background: none;
        border: none;
        font-size: 1.5rem;
        cursor: pointer;
        color: var(--text-light);
        width: 32px;
        height: 32px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        }

        .close-coupon:hover {
        background: var(--border);
        color: var(--text);
        }

        .coupon-modal-body {
        padding: 0 1.5rem 1.5rem;
        }

        @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
        }

        @keyframes slideUp {
        from { 
            opacity: 0;
            transform: translateY(20px) scale(0.95);
        }
        to { 
            opacity: 1;
            transform: translateY(0) scale(1);
        }
        }

        @media (max-width: 768px) {
        .coupon-modal {
            margin: 1rem;
            width: calc(100% - 2rem);
        }
        }


        .extra-price-badge {
          background: white;
          padding: 0.4rem 0.8rem;
          border-radius: 2rem;
          font-weight: 700;
          font-size: 0.9rem;
          color: var(--success);
          box-shadow: 0 2px 8px rgba(0,0,0,0.1);
        }

        /* 👇 NOVOS ESTILOS PARA CUPOM */
        .coupon-section {
          background: linear-gradient(135deg, #f8fafc, #f1f5f9);
          border: 2px dashed var(--border);
          border-radius: 1rem;
          padding: 1.5rem;
          margin-bottom: 1.5rem;
          transition: all 0.3s;
        }
        .coupon-section:hover {
          border-color: var(--primary);
          background: linear-gradient(135deg, #f0f9ff, #e0f2fe);
        }
        .coupon-input-group {
          display: flex;
          gap: 0.75rem;
          margin-bottom: 1rem;
        }
        .coupon-input {
          flex: 1;
          padding: 0.75rem 1rem;
          border: 2px solid var(--border);
          border-radius: 0.5rem;
          font-size: 1rem;
          transition: border-color 0.3s;
        }
        .coupon-input:focus {
          outline: none;
          border-color: var(--primary);
          box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.1);
        }
        .btn-coupon {
          padding: 0.75rem 1.5rem;
          border: none;
          border-radius: 0.5rem;
          background: var(--primary);
          color: white;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s;
          white-space: nowrap;
        }
        .btn-coupon:hover:not(:disabled) {
          background: var(--primary-dark);
          transform: translateY(-1px);
        }
        .btn-coupon:disabled {
          background: #9CA3AF;
          cursor: not-allowed;
          transform: none;
        }
        .coupon-message {
          padding: 0.75rem 1rem;
          border-radius: 0.5rem;
          font-size: 0.9rem;
          font-weight: 500;
          margin-top: 0.5rem;
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }
        .coupon-success {
          background: rgba(16, 185, 129, 0.1);
          color: var(--success);
          border: 1px solid rgba(16, 185, 129, 0.2);
        }
        .coupon-error {
          background: rgba(239, 68, 68, 0.1);
          color: var(--error);
          border: 1px solid rgba(239, 68, 68, 0.2);
        }
        .coupon-applied {
          background: linear-gradient(135deg, var(--success), #059669);
          color: white;
          border: none;
          padding: 0.75rem 1rem;
          border-radius: 0.5rem;
          font-size: 0.9rem;
          text-align: center;
          margin-bottom: 1rem;
        }
        .btn-remove-coupon {
          background: var(--error);
          color: white;
          border: none;
          padding: 0.5rem 1rem;
          border-radius: 0.5rem;
          font-size: 0.8rem;
          cursor: pointer;
          margin-left: 0.5rem;
        }
        .btn-remove-coupon:hover {
          background: #dc2626;
        }

        .music-summary { background: #f9fafb; border-radius: 1rem; padding: 1.5rem; margin-top: 2rem; border-left: 4px solid var(--primary); }
        .summary-item { display: flex; justify-content: space-between; padding: 0.75rem 0; border-bottom: 1px solid var(--border); font-size: 0.95rem; }
        .summary-item:last-child { border-bottom: none; }

        .pricing-section { position: sticky; top: 2rem; }
        .price-card { background: white; border-radius: 1.5rem; padding: 2rem; box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08); border: 2px solid var(--border); }
        
        .price-breakdown { margin-bottom: 1.5rem; }
        .price-row { 
          display: flex; 
          justify-content: space-between; 
          padding: 0.6rem 0; 
          font-size: 0.95rem;
          color: var(--text-light);
        }
        .price-row.extra { color: var(--success); font-weight: 600; }
        .price-row.discount { color: var(--success); font-weight: 700; font-size: 1rem; }
        
        .total-display { padding-top: 1.5rem; border-top: 2px solid var(--border); }
        .total-row { display: flex; justify-content: space-between; align-items: center; margin-bottom: 0.2rem; }
        .total-label { font-size: 1.1rem; font-weight: 700; }
        .total-amount { font-size: 2rem; font-weight: 700; color: var(--primary); }

        .btn-pay { 
          width: 100%; 
          padding: 1.2rem; 
          border: none; 
          border-radius: 0.75rem; 
          background: linear-gradient(135deg, var(--primary), var(--secondary)); 
          color: white; 
          font-weight: 700; 
          font-size: 1.1rem; 
          cursor: pointer; 
          transition: transform 0.3s, box-shadow 0.3s; 
        }
        .btn-pay:hover { transform: translateY(-2px); box-shadow: 0 10px 25px rgba(139, 92, 246, 0.4); }
        
        .revisions-badge {
          display: inline-flex;
          align-items: center;
          gap: 0.3rem;
          background: rgba(16, 185, 129, 0.1);
          color: var(--success);
          padding: 0.3rem 0.6rem;
          border-radius: 0.5rem;
          font-size: 0.8rem;
          font-weight: 600;
          margin-left: 0.5rem;
        }
        
        .modal { display: none; position: fixed; z-index: 2000; left: 0; top: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.6); align-items: center; justify-content: center; backdrop-filter: blur(4px); }
        .modal.show { display: flex; }
        .modal-content { background: white; padding: 3rem; border-radius: 1.5rem; text-align: center; max-width: 400px; }
        
        @media (max-width: 1000px) { 
          .checkout-container { grid-template-columns: 1fr; } 
          .plans-display { grid-template-columns: 1fr; } 
          .extra-offer-toggle { flex-wrap: wrap; }
          .coupon-input-group { flex-direction: column; }
        }

        /* Estilos restantes permanecem iguais... */
        .order-header {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          margin-bottom: 1.5rem;
        }
        .header-icon {
          font-size: 1.8rem;
        }
        .order-title {
          margin: 0;
          font-size: 1.25rem;
          font-weight: 700;
        }

        .trust-section {
          background: rgba(16, 185, 129, 0.03);
          border-radius: 0.75rem;
          padding: 1rem;
          border: 1px solid rgba(16, 185, 129, 0.2);
          text-align: center;
        }
        .trust-line {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.75rem;
          font-size: 0.85rem;
          margin-bottom: 0.5rem;
        }
        .trust-icon {
          color: var(--success);
        }
        .trust-features {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 1rem;
          font-size: 0.8rem;
          color: var(--text-light);
          margin-bottom: 1rem;
        }

        /* RESPONSIVO */
        @media (max-width: 768px) {
          .guarantee-item {
            flex-direction: column;
            align-items: flex-start;
            gap: 0.25rem;
          }
          .trust-features {
            flex-direction: column;
            gap: 0.5rem;
          }
          .trust-section {
            margin: 1rem -1rem 0 -1rem;
            border-radius: 0 0 0.75rem 0.75rem;
          }
        }
      `}</style>

      <nav>
        <div className="nav-container">
          <div className="logo">🎵 Cantando Vidas</div>
          <div style={{ color: 'var(--text-light)', fontSize: '0.9rem' }}>Finalizar Pedido</div>
        </div>
      </nav>

      <div className="checkout-container">
        {/* Coluna da Esquerda - SEM MUDANÇAS */}
        <div className="order-section">
          <h2 className="section-title">Escolha seu Plano de Entrega</h2>
          
          <div className="plans-display">
            
            <div 
            
              className={`plan-box ${selectedTime === '24h' ? 'active' : ''}`}
              onClick={() => setSelectedTime('24h')}
            >
              {/* Preço antigo */}
              <div style={{
                fontSize: '1rem',
                color: '#5e6a7a',
                textDecoration: 'line-through',
                marginBottom: '0.25rem'
                }}>
                R$ 89,90
              </div>
              <div className="plan-time">Entrega em 24h</div>
              <div className="plan-price">R$ 47,90</div>
              <ul className="plan-features">
                <li>1 Revisão inclusa</li>
                <li>Qualidade Premium</li>
              </ul>
            </div>

            <div 
              className={`plan-box ${selectedTime === '48h' ? 'active' : ''}`}
              onClick={() => setSelectedTime('48h')}
            >
              <div style={{
                fontSize: '1rem',
                color: '#5e6a7a',
                textDecoration: 'line-through',
                marginBottom: '0.25rem'
                }}>
                R$ 59,90
              </div>
              <div className="plan-time">Entrega em 48h</div>
              <div className="plan-price">R$ 27,90</div>
              <ul className="plan-features">
                <li>1 Revisão inclusa</li>
                <li>Qualidade Premium</li>
              </ul>
            </div>
          </div>

          <div 
            className={`extra-offer-toggle ${extraRevision ? 'selected' : ''}`}
            onClick={() => setExtraRevision(!extraRevision)}
          >
            <div className="extra-offer-content">
              <span className="extra-offer-icon">{extraRevision ? '✅' : '💜'}</span>
              <div className="extra-offer-text">
                <strong>+ 1 Revisão Extra</strong><br/>
                Mais segurança pra ficar do jeitinho que você imaginou!
              </div>
            </div>
            <span className="extra-price-badge">+ R$ 7,90</span>
            <label className="toggle-switch" onClick={(e) => e.stopPropagation()}>
              <input 
                type="checkbox" 
                checked={extraRevision} 
                onChange={(e) => setExtraRevision(e.target.checked)}
              />
              <span className="toggle-slider"></span>
            </label>
          </div>

          <div className="pricing-section">
            <div className="price-card">
              <h3>📋 Resumo do Seu Pedido</h3>
              <div style={{ background: '#f8fafc', padding: '1.5rem', borderRadius: '0.5rem', marginBottom: '1.5rem' }}>
                {quizData.typeGroup === 'pessoa' ? (
                  <>
                    <p style={{ margin: '0.5rem 0', fontSize: '0.9rem' }}>
                      <strong>Para:</strong> {recipientLabels[quizData.recipient] || quizData.recipientOther}
                    </p>
                    <p style={{ margin: '0.5rem 0', fontSize: '0.9rem' }}>
                      <strong>Nome:</strong> {quizData.personName}
                    </p>
                  </>
                ) : (
                  <>
                    <p style={{ margin: '0.5rem 0', fontSize: '0.9rem' }}>
                      <strong>Tipo de Evento:</strong> {eventTypeLabels[quizData.eventType] || quizData.eventOther}
                    </p>
                    <p style={{ margin: '0.5rem 0', fontSize: '0.9rem' }}>
                      <strong>Nome/Detalhes:</strong> {quizData.eventNames || 'Não informado'}
                    </p>
                  </>
                )}

                <p style={{ margin: '0.5rem 0', fontSize: '0.9rem' }}>
                  <strong>Estilo:</strong> {styleLabels[quizData.style] || quizData.styleOther}
                </p>
                <p style={{ margin: '0.5rem 0', fontSize: '0.9rem' }}>
                  <strong>Voz:</strong> {voiceLabels[quizData.voice || 'Não informado']}
                </p>
                <p style={{ margin: '0.5rem 0', fontSize: '0.9rem' }}>
                  <strong>Detalhes:</strong> {quizData.qualities || 'Não informado'}
                </p>
                <p style={{ margin: '0.5rem 0', fontSize: '0.9rem' }}>
                  <strong>Memórias:</strong> {quizData.memories || 'Não informado'}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* 👇 COLUNA DA DIREITA COM CUPOM */}
        <div className="pricing-section">
        <div className="price-card">
            <div className="order-header">
                <div className="header-icon">🛒</div>
                    <div>
                        <h3 className="order-title">Resumo do seu Pedido</h3>
                        <span className="revisions-badge">
                        🔄 {totalRevisions} {totalRevisions > 1 ? 'revisões' : 'revisão'}
                        </span>
                    </div>
                </div>

                

            {/* FRASE CLICÁVEL ACIMA DO TOTAL */}
            <div
                className={`coupon-trigger ${couponDiscount > 0 ? 'has-discount' : ''}`}
                onClick={() => setShowCouponInput(true)}
                style={{
                    marginBottom: '1rem',
                    cursor: 'pointer',
                    fontSize: '0.9rem',
                    color: 'var(--primary)',
                    textAlign: 'center',
                    padding: '0.5rem',
                    borderRadius: '0.5rem',
                    background: 'rgba(139, 92, 246, 0.05)',
                    transition: 'all 0.3s',
                }}
                >
                {couponDiscount > 0 ? (
                    <div className="coupon-applied-compact"
                        onClick={(e) => e.stopPropagation()} // evita abrir popup ao clicar no botão
                        >
                        <span>
                            🎟️ {couponCode} aplicado ( {couponType === 'percentage'
                            ? `${couponDiscount}% OFF`
                            : `R$ ${couponDiscount.toFixed(2).replace('.', ',')} OFF` } )
                        </span>

                        <button className="btn-remove-coupon-compact"
                            onClick={removeCoupon} > ×
                        </button>
                    </div>
                ) : (
                    '🎟️ Tem cupom de desconto? Clique aqui'
                )}
            </div>

            {/* BREAKDOWN */}
            <div className="price-breakdown">
            <div className="price-row">
                <span className="price-label">⚡ {currentBase.label}</span>
                <span className="price-value">
                R$ {currentBase.basePrice.toFixed(2).replace('.', ',')}
                </span>
            </div>
            {extraRevision && (
                <div className="price-row extra">
                <span className="price-label">🔄 + Revisão extra</span>
                <span className="price-value extra">
                    +R$ {EXTRA_REVISION_PRICE.toFixed(2).replace('.', ',')}
                </span>
                </div>
            )}
            
            </div>

            <div className="total-display">
            <div className="total-row">
                <span className="total-label">Subtotal</span>
                <span className="total-amount" style={{ fontSize: '1.3rem' }}>
                R$ {subtotal.toFixed(2).replace('.', ',')}
                </span>
            </div>

            {couponDiscount > 0 && (
                <div className="price-row extra">
                <span className="price-label">🎟️ Cupom {couponCode}</span>
                <span className="price-value">
                   - R$ {discountValue.toFixed(2).replace('.', ',')}
                </span>
                </div>
            )}

            {couponDiscount > 0 && (
                <div className="total-row">
                    <span className="total-label">Total</span>
                    <span className="total-amount" style={{fontSize: '1.8rem' }}>
                    R$ {totalPrice.toFixed(2).replace('.', ',')}
                    </span>
                </div>
            )}

            <button
                className="btn-pay enhanced"
                onClick={handleBuy}
                style={{ marginBottom: '1rem' }}
            >
                <span className="btn-primary-text">Criar Minha Música Agora<br/>Ir para Pagamento</span>
            </button>

            {/* TRUST SECTION */}
            <div className="trust-section">
                <div className="trust-line">
                <span className="trust-icon">✅</span>
                <span>
                    Pagamento 100% seguro via<br /> Mercado Pago
                </span>
                <span className="trust-icon">✅</span>
                </div>
                <div className="trust-features">
                <span>• Sem taxas ocultas</span>
                <span>• Cancelamento fácil</span>
                <span>• Suporte 24h</span>
                </div>

                <div className="payment-methods">
                <span className="payment-icon">💳</span>
                <span className="payment-icon">📱</span>
                <span className="payment-icon">💰</span>
                <div className="payment-labels">Cartão • PIX • Boleto</div>
                </div>
            </div>
            </div>
        </div>

        {/* 👇 MODAL SIMPLES DO CUPOM (DENTRO DO price-card / após o primeiro bloco) */}
        {showCouponInput && (
            <div className="coupon-modal-overlay" onClick={() => setShowCouponInput(false)}>
            <div className="coupon-modal" onClick={(e) => e.stopPropagation()}>
                <div className="coupon-modal-header">
                <h4>🎟️ Aplicar Cupom</h4>
                <button className="close-coupon" onClick={() => setShowCouponInput(false)}>
                    ×
                </button>
                </div>

                <div className="coupon-modal-body">
                <div className="coupon-input-group">
                    <input
                    type="text"
                    className="coupon-input"
                    placeholder="Digite o código do cupom"
                    value={couponCode}
                    onChange={(e) => setCouponCode(e.target.value.toUpperCase())}
                    autoFocus
                    />
                    <button
                    className="btn-coupon"
                    onClick={applyCoupon}
                    disabled={isApplyingCoupon}
                    >
                    {isApplyingCoupon ? '⏳' : 'Aplicar'}
                    </button>
                </div>

                {couponError && (
                    <div className="coupon-message coupon-error">
                    <span>⚠️</span>
                    {couponError}
                    </div>
                )}
                </div>
            </div>
            </div>
        )}
        </div>

      </div>
      
      <div className={`modal ${isModalOpen ? 'show' : ''}`}>
        <div className="modal-content">
          <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>⏳</div>
          <h3 style={{ marginBottom: '0.5rem' }}>Redirecionando...</h3>
          <p style={{ color: 'var(--text-light)' }}>Você será levado ao checkout seguro em instantes.</p>
        </div>
      </div>
    </div>
  );
};

export default Checkout;
